import axios from 'axios'

const instance = axios.create({
    baseURL:'https://pick-book.herokuapp.com',
    timeout:5000,
    headers:{"X-custom-Header":'foobar'}
})


export default instance
